// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2gTgp","select":"Header_select__79d31","clinic":"Header_clinic__2gkRg"};